import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

const UnauthenticatedAccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        bgcolor: 'grey.50',
        p: 2
      }}
    >
      <Card 
        sx={{ 
          maxWidth: 500, 
          width: '100%', 
          textAlign: 'center',
          borderRadius: 3,
          boxShadow: 3
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 3
            }}
          >
            <LockIcon 
              sx={{ 
                fontSize: 48, 
                color: 'error.main',
                mr: 2
              }} 
            />
            <Typography 
              variant="h4" 
              fontWeight="bold" 
              color="error.main"
            >
              Access Denied
            </Typography>
          </Box>
          
          <Typography 
            variant="h6" 
            color="text.secondary" 
            sx={{ mb: 2 }}
          >
            You are not allowed to view this page
          </Typography>
          
          <Typography 
            variant="body1" 
            color="text.secondary" 
            sx={{ mb: 3 }}
          >
            Please log in to access private profiles
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              p: 2,
              bgcolor: 'grey.100',
              borderRadius: 2,
              mb: 3
            }}
          >
            <CircularProgress size={20} />
            <Typography variant="body2" color="text.secondary">
              Redirecting to home page in {countdown} seconds...
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary">
            If you are not redirected automatically, please click{' '}
            <Typography 
              component="span" 
              color="primary.main" 
              sx={{ 
                textDecoration: 'underline', 
                cursor: 'pointer' 
              }}
              onClick={() => navigate('/')}
            >
              here
            </Typography>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default UnauthenticatedAccessDenied;
